import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";
import i18next from "i18next";

// export const getSubstores = async (company_id) => {
//   try {
//     const payload = {
//       lang: i18next.language === "ar" ? "ar_001" : "en_US",
//       company_id: company_id,
//     };
//     const response = await axiosInstance.post(URLS.GET_SUB_STORE, payload);

//     if (response.data?.result?.status_code == 200) {
//       return response?.data?.result;
//     } else {
//       return response;
//     }
//   } catch (error) {
//     return error;
//   }
// };

export const searchSubstoreInventory = async (
  name,
  parent_store_id,
  child_store_id,
) => {
  try {

    const payload = {
      product_name: name,
      parent_store_id: parent_store_id,
      child_store_id: child_store_id,
      limit: 10,
      offset: 0,
      lang: i18next.language === 'ar' ? 'ar_001' : 'en_US',


    };
    const response = await axiosInstance.post(
      URLS.SEARCH_SUBSTORE_INVENTORY,
      payload
    );
    return response.data;
  } catch (error) {
    return error;
  }
};


export const createStockTransfer = async (payload) => {
  try {
    const response = await axiosInstance.post(
      URLS.CREATE_STOCK_TRANSFER,
      payload
    );

    console.log("responsse data", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating purchase order:", error);
    throw error; // Rethrow the error for handling in the calling function
  }
};




export const GetStockTransferReport = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_STOCK_REPORT, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};


export const getStockOrderLines = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_STOCK_ORDER_LINES, payload);
    console.log("GET_STOCK_ORDER_LINES RES", response);

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const UpdateStockTransfer = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.CANCEL_STOCK_TRANSFER, payload);

    return response?.data;
  } catch (error) {
    return error;
  }
};

